import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, NumberInput, DropdownSelector, CheckBox } from 'hyperdb-utils';
import { TemplateSelector } from '../../template/containers';

class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.api.emailTemplate.getData({
      url: '/types',
      propName: 'templateTypes',
    });
    /* this.props.api.automaticSending.setData({
      defined_template: !this.props.objectData.template_id.value[1] || this.props.objectData.template_id.value[1] === '0',
      last_message_defined_template: !this.props.objectData.last_message_template_id.value[1] || this.props.objectData.last_message_template_id.value[1] === '0',
    });*/
  }
  render() {
    return (
      <fieldset>
        <CheckBox
          label="Activated"
          name="activated"
          checked={ this.props.objectData.activated }
          onChange={ this.handleClickCheckbox.bind(this, 'activated') }
        />
        <CheckBox
          label="Quote last message"
          name="quote_last_message"
          checked={ this.props.objectData.quote_last_message }
          onChange={ this.handleClickCheckbox.bind(this, 'quote_last_message') }
        />
        <TextInput
          label="Name *"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <TemplateSelector
          labelType="Type *"
          labelTemplate="Template"
          type={ this.props.objectData.type }
          useDefinedTemplate={ this.props.defined_template }
          template={ this.props.objectData.template_id.value[1] }
          filterCodes={ [118, 119] }
          onChangeTemplateType={ this.handleChangeTemplate.bind(this, 'type') }
          onChangeChooseDefinedTemplate={ this.handleChangeTemplate.bind(this, 'defined_template') }
          onChangeTemplate={ this.handleChangeTemplate.bind(this, 'template_id') }
        />
        <NumberInput
          label="Days since last message *"
          name="days_since_last_message"
          value={ this.props.objectData.days_since_last_message }
          onChange={ this.handleChange.bind(this, 'days_since_last_message') }
        />
        <TemplateSelector
          labelType="Last message type *"
          labelTemplate="Last message template"
          type={ this.props.objectData.last_message_type }
          useDefinedTemplate={ this.props.last_message_defined_template }
          template={ this.props.objectData.last_message_template_id.value[1] }
          onChangeTemplateType={ this.handleChangeTemplate.bind(this, 'last_message_type') }
          onChangeChooseDefinedTemplate={ this.handleChangeTemplate.bind(this, 'last_message_defined_template') }
          onChangeTemplate={ this.handleChangeTemplate.bind(this, 'last_message_template_id') }
        />
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
  handleClickCheckbox(attributeName, field) {
    const activated = !this.props.objectData[attributeName];
    this.props.updateEditedObject({ attributeName, value: activated });
  }
  handleChangeTemplate(attributeName, value) {
    if (attributeName === 'type') {
      this.props.updateEditedObject({ attributeName, value });
    }
    /* if (attributeName === 'defined_template') {
      this.props.api.automaticSending.setData({ defined_template: value });
    }*/
    if (attributeName === 'template_id') {
      const relation = { ...this.props.objectData.template_id };
      relation.value[1] = value;
      this.props.updateEditedObject({ attributeName, value: relation });
    }
    if (attributeName === 'last_message_type') {
      this.props.updateEditedObject({ attributeName, value });
    }
    /* if (attributeName === 'last_message_defined_template') {
      this.props.api.automaticSending.setData({ last_message_defined_template: value });
    }*/
    if (attributeName === 'last_message_template_id') {
      const relation = { ...this.props.objectData.last_message_template_id };
      relation.value[1] = value;
      this.props.updateEditedObject({ attributeName, value: relation });
    }
  }
}

function onSubmit(props) {
  const objectData = { ...props.objectData };
  // if (props.defined_template) objectData.template_id = 0;
  // if (props.last_message_defined_template) objectData.last_message_template_id = 0;
  const submit = !props.objectData.id
    ? props.api.automaticSending.submitCreateForm(objectData)
    : props.api.automaticSending.submitEditForm({ id: props.objectData.id, objectData });
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default HyperdbForm(Form, {
  namespace: 'automaticSending',
  mountedUrl: '/email/automatic-sendings',
  titleNew: 'Create new automatic email',
  titleEdit: 'Edit automatic email',
  displayName: (object) => object.name,
  onSubmit,
  checkIsValid: (props) => {
    return !!props.objectData.name && !!props.objectData.type && props.objectData.days_since_last_message > 0 && !!props.objectData.last_message_type;
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/automatic-sending/containers/Form.jsx